import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Lock, Mail, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenido de vuelta");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Error al iniciar sesión");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#0A0908] grain flex items-center justify-center px-5 relative">
      <div className="orb-gold w-[500px] h-[500px] left-[-140px] top-[-100px]" />
      <div className="orb-gold w-[500px] h-[500px] right-[-140px] bottom-[-100px] opacity-70" />
      <div className="max-w-md w-full relative">
        <a href="/" className="flex items-center gap-3 justify-center mb-10">
          <img src="/logo-lineas-doradas.webp" alt="Líneas Doradas" className="h-14 w-14 object-contain" />
          <div>
            <div className="font-display text-xl text-[#F5EFE0]">Líneas Doradas</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]">Panel administrativo</div>
          </div>
        </a>

        <form onSubmit={submit} data-testid="admin-login-form" className="card-lux p-8 space-y-5">
          <h1 className="font-display text-3xl text-[#F5EFE0]">Ingresa a tu panel</h1>
          <p className="text-sm text-[#F5EFE0]/55 -mt-3">Gestiona cotizaciones, flota, testimonios y rutas.</p>

          <div>
            <label className="text-xs text-[#F5EFE0]/60 mb-1.5 block">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#D4AF37]" />
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                     className="w-full bg-[#171412] border border-[#3A3229] rounded-lg pl-10 pr-4 py-3 text-[#F5EFE0] placeholder-[#F5EFE0]/40 focus:border-[#D4AF37] outline-none"
                     placeholder="lineasdoradas@gmail.com" />
            </div>
          </div>
          <div>
            <label className="text-xs text-[#F5EFE0]/60 mb-1.5 block">Contraseña</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#D4AF37]" />
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                     className="w-full bg-[#171412] border border-[#3A3229] rounded-lg pl-10 pr-4 py-3 text-[#F5EFE0] placeholder-[#F5EFE0]/40 focus:border-[#D4AF37] outline-none"
                     placeholder="••••••••" />
            </div>
          </div>
          <button data-testid="login-submit" type="submit" disabled={loading} className="btn-gold w-full py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-70">
            {loading && <Loader2 size={16} className="animate-spin" />}
            {loading ? "Entrando…" : "Ingresar"}
          </button>
          <div className="text-center">
            <a href="/admin/reset-password" data-testid="forgot-password-link" className="text-xs text-[#E8C87A]/80 hover:text-[#E8C87A]">
              ¿Olvidaste tu contraseña?
            </a>
          </div>
        </form>
        <div className="text-center mt-6">
          <a href="/" className="text-xs text-[#F5EFE0]/50 hover:text-[#E8C87A]">← Volver al sitio</a>
        </div>
      </div>
    </div>
  );
}
